var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import RemoveIcon from '@mui/icons-material/Close';
import { Card, CardActionArea, CardContent, IconButton, Skeleton, Tooltip } from '@mui/material';
import { USER_PUBLIC_NO_AUTH } from 'common/graphql/queries/user/user-public';
import UserAvatar from 'components/UserAvatar/UserAvatar';
import { useTranslation } from 'react-i18next';
import { clearLoginHistory } from 'services/user-login-history';
import history from 'store/history';
import { handleTelegramLogin } from '../SocialSignIn/TelegramSignIn/TelegramSignInButton';
import { handleVkogin } from '../SocialSignIn/VKSignIn/VKSignInButton';
import { handleYandexLogin } from '../SocialSignIn/YandexSignIn/YandexSignInButton';
var UserLoginOtherAccountCard = function (_a) {
    var _b, _c, _d, _e, _f;
    var userLoginHistory = _a.userLoginHistory, setEmail = _a.setEmail, setValue = _a.setValue, setUserLoginHistory = _a.setUserLoginHistory;
    var t = useTranslation().t;
    var _g = useQuery(USER_PUBLIC_NO_AUTH, {
        variables: {
            userId: userLoginHistory.userId
        }
    }), data = _g.data, loading = _g.loading;
    var getLoginInfo = function () {
        switch (userLoginHistory.loginType) {
            case 0: {
                return {
                    loginInfoText: userLoginHistory.loginInfo || '',
                    onClick: function () {
                        setEmail(userLoginHistory.loginInfo || '');
                        setValue(1);
                        history.push("/login");
                    }
                };
            }
            case 1: {
                return {
                    loginInfoText: t('Вход через') + ' ' + 'Google',
                    onClick: function () {
                        setValue(1);
                        history.push("/login");
                    }
                };
            }
            case 2: {
                return {
                    loginInfoText: t('Вход через') + ' ' + 'Vk',
                    onClick: function () {
                        handleVkogin();
                    }
                };
            }
            case 3: {
                return {
                    loginInfoText: t('Вход через') + ' ' + 'Yandex',
                    onClick: function () {
                        handleYandexLogin();
                    }
                };
            }
            case 4: {
                return {
                    loginInfoText: t('Вход через') + ' ' + 'Telegram',
                    onClick: function () {
                        handleTelegramLogin();
                    }
                };
            }
            case 5: {
                return {
                    loginInfoText: t('Вход через') + ' ' + 'Strava',
                    onClick: function () { }
                };
            }
        }
    };
    if (loading)
        return (_jsx(Card, { children: _jsx(CardContent, { children: _jsxs("div", __assign({ className: "flex flex-row space-x-10 items-center" }, { children: [_jsx(Skeleton, { variant: "circular", sx: { width: 60, height: 60 } }, void 0), _jsxs("div", __assign({ className: "flex flex-col space-y-5" }, { children: [_jsx(Skeleton, { variant: "rectangular", sx: { width: 160, height: 16 } }, void 0), _jsx(Skeleton, { variant: "rectangular", sx: { width: 140, height: 14 } }, void 0), _jsx(Skeleton, { variant: "rectangular", sx: { width: 120, height: 12 } }, void 0)] }), void 0)] }), void 0) }, void 0) }, void 0));
    return !loading && (data === null || data === void 0 ? void 0 : data.userPublic) ? (_jsx(Card, { children: _jsx(CardActionArea, __assign({ className: "flex flex-row items-center", onClick: function () {
                var loginInfo = getLoginInfo();
                if (loginInfo)
                    loginInfo.onClick();
            }, component: "div" }, { children: _jsx(CardContent, { children: _jsxs("div", __assign({ className: "flex flex-row justify-between items-center w-280" }, { children: [_jsxs("div", __assign({ className: "flex flex-row space-x-10 items-center" }, { children: [_jsx(UserAvatar, { style: "xs:w-60 xs:h-60 text-28", firstName: (_b = data.userPublic.mainSettings) === null || _b === void 0 ? void 0 : _b.firstName, profilePhoto: (_c = data.userPublic.mainSettings) === null || _c === void 0 ? void 0 : _c.profilePhoto }, void 0), _jsxs("div", __assign({ className: "flex flex-col space-y-5" }, { children: [_jsxs("p", __assign({ className: "[overflow-wrap:anywhere]" }, { children: [(_d = data.userPublic.mainSettings) === null || _d === void 0 ? void 0 : _d.firstName, " ", (_e = data.userPublic.mainSettings) === null || _e === void 0 ? void 0 : _e.lastName] }), void 0), _jsx("p", __assign({ className: "text-12 text-grey" }, { children: ((_f = getLoginInfo()) === null || _f === void 0 ? void 0 : _f.loginInfoText) || '' }), void 0), userLoginHistory.lastActiveDate && (_jsx("p", __assign({ className: "text-12 text-grey" }, { children: _jsx("span", { children: new Date(userLoginHistory.lastActiveDate)
                                                    .toLocaleString()
                                                    .substring(0, 17) }, void 0) }), void 0))] }), void 0)] }), void 0), _jsx(Tooltip, __assign({ title: t('Удалить из истории входа') }, { children: _jsx(IconButton, __assign({ onClick: function (e) {
                                    e.stopPropagation();
                                    setUserLoginHistory(clearLoginHistory(userLoginHistory));
                                } }, { children: _jsx(RemoveIcon, { className: "text-grey" }, void 0) }), void 0) }), void 0)] }), void 0) }, void 0) }), void 0) }, void 0)) : null;
};
export default UserLoginOtherAccountCard;
